import { NgModule } from "@angular/core";
import { FormControlPipe } from "../pipes/form-control.pipe";
import { IonicModule } from "@ionic/angular";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatTooltip } from "@angular/material/tooltip";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { MatProgressBar } from "@angular/material/progress-bar";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTableModule,
} from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { MatSortModule } from "@angular/material/sort";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import {
  MatTimepicker,
  MatTimepickerInput,
  MatTimepickerToggle,
} from "@angular/material/timepicker";
import { MatInput } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { QuillEditorComponent } from "ngx-quill";
import { HeaderComponent } from "./header/header.component";
import { HazardOverviewComponent } from "./hazard-overview/hazard-overview.component";
import { FileOverviewComponent } from "./file-overview/file-overview.component";
import { TerminBearbeitenComponent } from "./termin-bearbeiten/termin-bearbeiten.component";
import { TerminHinzufuegenComponent } from "./termin-hinzufuegen/termin-hinzufuegen.component";
import { AktortBearbeitenComponent } from "./aktort-bearbeiten/aktort-bearbeiten.component";
import { ComposeEmailComponent } from "./compose-email/compose-email.component";
import { RueckfrageAnEmailComponent } from "./rueckfrage-an-email/rueckfrage-an-email.component";
import { KontaktdatenComponent } from "./kontaktdaten/kontaktdaten.component";
import { KontaktdatenAnsichtModalComponent } from "./kontaktdaten-ansicht-modal/kontaktdaten-ansicht-modal.component";
import { TerminWeitersetzenKommentarComponent } from "./termin-weitersetzen-kommentar/termin-weitersetzen-kommentar.component";
import { EmailAbwesenheitsbenachrichtigungenListComponent } from "./email-abwesenheitsbenachrichtigungen-list/email-abwesenheitsbenachrichtigungen-list.component";
import { EmailAbwesenheitsbenachrichtigungComponent } from "./email-abwesenheitsbenachrichtigung/email-abwesenheitsbenachrichtigung.component";
import { EmailContentComponent } from "./email-content/email-content.component";
import { AktsucheSuchbereichComponent } from "./aktsuche-suchbereich/aktsuche-suchbereich.component";
import { TextvorlageQuickSelectComponent } from "./textvorlage-quick-select/textvorlage-quick-select.component";
import { LoveItTextareaTextvorlageComponent } from "../form-controls/love-it-textbaustein-textarea/love-it-textarea-textvorlage.component";
import { AktGeraeteListComponent } from "./akt-geraete-list/akt-geraete-list.component";
import { AktGeraetComponent } from "./akt-geraet/akt-geraet.component";
import { LoveItInputComponent } from "../form-controls/love-it-input/love-it-input.component";
import { PdfViewerComponent } from "./pdf-viewer/pdf-viewer.component";
import { TermintabelleTerminlisteComponent } from "./termintabelle-terminliste/termintabelle-terminliste.component";
import { GutachtenUebergebenComponent } from "./gutachten-uebergeben/gutachten-uebergeben.component";
import { PopupInfoModalComponent } from "./popup-info-modal/popup-info-modal.component";
import { KalkulationFavoritenListComponent } from "./kalkulation-favoriten-list/kalkulation-favoriten-list.component";
import { KalkulationVorlagenListComponent } from "./kalkulation-vorlagen-list/kalkulation-vorlagen-list.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

@NgModule({
  declarations: [
    FormControlPipe,
    HeaderComponent,
    HazardOverviewComponent,
    FileOverviewComponent,
    TerminBearbeitenComponent,
    TerminHinzufuegenComponent,
    AktortBearbeitenComponent,
    ComposeEmailComponent,
    RueckfrageAnEmailComponent,
    KontaktdatenComponent,
    KontaktdatenAnsichtModalComponent,
    TerminWeitersetzenKommentarComponent,
    EmailAbwesenheitsbenachrichtigungenListComponent,
    EmailAbwesenheitsbenachrichtigungComponent,
    EmailContentComponent,
    AktsucheSuchbereichComponent,
    TextvorlageQuickSelectComponent,
    LoveItTextareaTextvorlageComponent,
    AktGeraeteListComponent,
    AktGeraetComponent,
    LoveItInputComponent,
    PdfViewerComponent,
    TermintabelleTerminlisteComponent,
    GutachtenUebergebenComponent,
    PopupInfoModalComponent,
    KalkulationFavoritenListComponent,
    KalkulationVorlagenListComponent,
  ],
  exports: [
    FormControlPipe,
    HeaderComponent,
    HazardOverviewComponent,
    FileOverviewComponent,
    TerminBearbeitenComponent,
    TerminHinzufuegenComponent,
    AktortBearbeitenComponent,
    ComposeEmailComponent,
    RueckfrageAnEmailComponent,
    KontaktdatenComponent,
    KontaktdatenAnsichtModalComponent,
    TerminWeitersetzenKommentarComponent,
    EmailAbwesenheitsbenachrichtigungenListComponent,
    EmailAbwesenheitsbenachrichtigungComponent,
    EmailContentComponent,
    AktsucheSuchbereichComponent,
    TextvorlageQuickSelectComponent,
    LoveItTextareaTextvorlageComponent,
    AktGeraeteListComponent,
    AktGeraetComponent,
    PdfViewerComponent,
    TermintabelleTerminlisteComponent,
    GutachtenUebergebenComponent,
    PopupInfoModalComponent,
    LoveItInputComponent,
    KalkulationFavoritenListComponent,
    KalkulationVorlagenListComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    NgOptimizedImage,
    RouterLink,
    MatTooltip,
    NgxDatatableModule,
    MatProgressBar,
    MatTableModule,
    MatHeaderCell,
    MatCell,
    MatIconModule,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatCellDef,
    MatHeaderCellDef,
    MatColumnDef,
    CdkDrag,
    CdkDropList,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    NgSelectModule,
    MatFormField,
    MatTimepicker,
    MatTimepickerToggle,
    MatInput,
    MatTimepickerInput,
    MatLabel,
    MatNativeDateModule,
    QuillEditorComponent,
    NgxExtendedPdfViewerModule,
  ],
})
export class UtilComponentsModule {}
